import {createAsyncThunk} from '@reduxjs/toolkit';

import {
    fetchTaxForecastDataByRequestId,
    ITaxForecastRequestIdArg,
    postTaxForecast,
    IUpdateTaxForecastArgs,
    updateTaxForecast,
} from 'pages/ais/submit-income-tax-forecast/api/api';
import {
    TTaxForecastCommonData,
} from 'pages/ais/submit-income-tax-forecast/model/types';
import {AIS3_SLICE} from 'store/slices/ais-slice/ais-slice-constants';

export const getTaxForecastDataByRequestId = createAsyncThunk<
    TTaxForecastCommonData, ITaxForecastRequestIdArg>(
        `${AIS3_SLICE}/getTaxForecastData`,
        async (args, {rejectWithValue}) => {
            try {
                const response = await fetchTaxForecastDataByRequestId(args);
                const {data} = response;
                return data;
            } catch (e) {
                return rejectWithValue(e);
            }
        },
    );

export const updateTaxForecastEntity = createAsyncThunk<
    string, IUpdateTaxForecastArgs>(
        `${AIS3_SLICE}/updateTaxForecastEntity`,
        async (args, {rejectWithValue}) => {
            try {
                const response = await updateTaxForecast(args);
                const {data} = response;
                return data;
            } catch (e) {
                return rejectWithValue(e);
            }
        },
    );

export const sendTaxForecast = createAsyncThunk<
    string, ITaxForecastRequestIdArg>(
        `${AIS3_SLICE}/sendTaxForecast`,
        async (args, {rejectWithValue}) => {
            try {
                const response = await postTaxForecast(args);
                const {data} = response;
                return data;
            } catch (e) {
                return rejectWithValue(e);
            }
        },
    );
